<script>
import Vue from 'vue';
import { RichTextEditorPlugin, Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar, Table } from "@syncfusion/ej2-vue-richtexteditor";
Vue.use(RichTextEditorPlugin);

export default {
    name: "ReferralNote",

    data() {

        return {
            templates: [],
            templateID: 0,
            referralNote: {
                id: 0,
                encounterID: this.$route.query.encounterID,
                patientID: this.$route.params.patientID,
                visitNo: this.$route.params.visitNo,
                userName: this.$root.username,
                cancelled: false,
                referralNotes: ``,
            },
        };
    },

    provide: {

     richtexteditor:[Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar, Table]
    },

    watch: {

        templateID() {
            if(!this.templateID) return;

            const templates = this.templates.filter(temp => temp.tempID == this.templateID);

            if(!templates.length) return;

            this.referralNote.referralNotes = templates[0].template;
        },
    },

    mounted() {

        Promise.all([ this.fetchReferralNote(), this.fetchTemplates() ]);
    },

    methods: {

        fetchTemplates() {

            return this.$http.get(`MedicalFile/GetMedicalNotesTemplateNames`).then(response => {
                this.templates = response.data;
            }).catch(() => {});
        },

        fetchReferralNote() {
            let url = `MedicalFile/GetPatientReferralNotesforEncounter`;
                url += `?PatientID=${this.$route.params.patientID}`;
                url += `&VisitNo=${this.$route.params.visitNo}`;
                url += `&EncounterID=${this.$route.query.encounterID}`;

            return this.$http.get(url).then(response => {
                this.referralNote = response.data.length ? response.data[0] : {
                    id: 0,
                    encounterID: this.$route.query.encounterID,
                    patientID: this.$route.params.patientID,
                    visitNo: this.$route.params.visitNo,
                    userName: this.$root.username,
                    cancelled: false,
                    referralNotes: ``
                };
            }).catch(() => {});
        },

        saveData() {

            this.$root.loading = true;
            this.$http.post(`MedicalFile/PatientReferral`, this.referralNote).then(response => {
                this.$root.loading = false;
                window.Swal.fire({ type: `success`, text: response.data, });
            }).catch(() => { this.$root.loading = false; });
        },

        printNote() {
            const url = `${this.$route.params.patientID}/${this.$route.params.visitNo}`;

            window.open(
            `/medical-file/referral-note-print/print/${url}`, 
            '_blank', `ReferralNotePreview`, 
            "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
<div class="w-full">
    <div class="md:w-1/4 sm:w-full p-tiny">
        <label for="grid-referral-note-template" class="label-control">Template:</label>
        <v-select class="text-xs bg-white" 
            :options="templates" 
            :reduce="temp => temp.tempID" 
            v-model="templateID" label="tempName" />
    </div>
    <div class="w-full p-tiny">
        <label for="referralNoteRTE" class="label-control">Notes:</label>
        <ejs-richtexteditor ref="referralNoteRTE" 
            v-model.trim="referralNote.referralNotes" 
            :toolbarSettings="{
              items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
              'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
              'LowerCase', 'UpperCase', 'SuperScript', 'SubScript' , '|',
              'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
              'Outdent', 'Indent', '|',
              'CreateTable', 'CreateLink', 'Image', '|', 
              'ClearFormat', 'Print', 'SourceCode', 'FullScreen', '|', 
              'Undo', 'Redo']
          }" 
        />
    </div>
    <div class="w-full p-tiny text-right">
        <button 
            @click.prevent="printNote"
            class="btn-sm btn-info text-xs rounded mr-6">
                <i class="fa fa-print"></i> Print</button>
        <button class="btn-sm btn-primary text-xs rounded" @click.prevent="saveData"><i class="fa fa-save"></i> Save</button>
    </div>
</div>
</template>
